export class BusinessUnit {
    [key: string]: any;
    id?: number;
    parentID?: number;
    name?: string;
    active?: boolean;
    unitName?: string;
    hrBusinessParterID?: number;
    unitManagerID?: number;
}   


// WEBPACK FOOTER //
// ./src/app/Models/BusinessUnit.ts